import { SingleDatePicker } from "@/components/SingleDatePicker";
import { PERIODS } from "@/lib/period";

// Reusable pill period filter (This Year / Last Year / Last 30 Days / All Time / Custom).
// `options` optionally restricts which keys are shown. Custom reveals two date pickers.
export const PeriodFilter = ({ value, onChange, from = "", to = "", onFrom, onTo, options, testid = "period", className = "" }) => {
  const opts = options ? PERIODS.filter((p) => options.includes(p.k)) : PERIODS;
  return (
    <div className={className}>
      <div className="flex flex-wrap items-center gap-1.5" data-testid={testid}>
        {opts.map((p) => (
          <button key={p.k} onClick={() => onChange(p.k)} data-testid={`${testid}-${p.k}`}
            className={`rounded-full px-3 py-1 text-xs font-600 transition-colors ${value === p.k ? "bg-[#9B2226] text-white" : "border border-zinc-800 bg-zinc-900 text-zinc-300 hover:bg-zinc-800"}`}>{p.label}</button>
        ))}
      </div>
      {value === "custom" && (
        <div className="mt-2 flex items-center gap-2" data-testid={`${testid}-custom-range`}>
          <SingleDatePicker value={from} onChange={onFrom} testid={`${testid}-from`} placeholder="From" className="w-[150px]" />
          <span className="text-xs text-zinc-500">to</span>
          <SingleDatePicker value={to} onChange={onTo} testid={`${testid}-to`} placeholder="To" className="w-[150px]" />
        </div>
      )}
    </div>
  );
};
